import { render, staticRenderFns } from "./MyDocuments.vue?vue&type=template&id=25cc466b"
import script from "./MyDocuments.vue?vue&type=script&lang=js"
export * from "./MyDocuments.vue?vue&type=script&lang=js"
import style0 from "./MyDocuments.vue?vue&type=style&index=0&id=25cc466b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports